/* Maven Nove — PDP thumbnail-kolom: stopt onderaan de hoofdfoto, pijltjes om door te bladeren.
   Alleen actief vanaf 561px. Onder die breedte wordt er niets aan de DOM toegevoegd:
   daar is de strip horizontaal en die blijft precies zoals hij is. */
(function () {
  var MQ = window.matchMedia('(min-width: 561px)');
  var built = [];

  function stepSize(thumbs) {
    var b = thumbs.querySelector('button');
    if (!b) return 82;
    var gap = parseFloat(getComputedStyle(thumbs).rowGap);
    return b.getBoundingClientRect().height + (isNaN(gap) ? 10 : gap);
  }

  function arrow(dir) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'mn-thumbnav mn-thumbnav--' + dir;
    b.setAttribute('aria-label', dir === 'up' ? 'Previous photos' : 'More photos');
    b.innerHTML = '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' +
      (dir === 'up' ? 'M18 15l-6-6-6 6' : 'M6 9l6 6 6-6') + '"/></svg>';
    return b;
  }

  function build(gallery) {
    var thumbs = gallery.querySelector('.thumbs');
    if (!thumbs || gallery.querySelector('.mn-thumbnav')) return;

    var up = arrow('up');
    var down = arrow('down');
    gallery.appendChild(up);
    gallery.appendChild(down);

    function sync() {
      var max = thumbs.scrollHeight - thumbs.clientHeight;
      var scrollable = max > 2;
      up.hidden = !scrollable;
      down.hidden = !scrollable;
      up.disabled = thumbs.scrollTop <= 1;
      down.disabled = thumbs.scrollTop >= max - 1;
    }
    /* Smooth scrollen hangt aan animatieframes; die lopen niet in elke situatie
       (verborgen tab, reduced motion, oudere browsers). Daarom altijd een
       vangnet: staat de kolom na 320 ms nog stil, dan zetten we hem hard. */
    function glide(delta) {
      var max = thumbs.scrollHeight - thumbs.clientHeight;
      var start = thumbs.scrollTop;
      var target = Math.max(0, Math.min(max, start + delta));
      if (target === start) return;
      try { thumbs.scrollTo({ top: target, behavior: 'smooth' }); }
      catch (e) { thumbs.scrollTop = target; }
      setTimeout(function () {
        if (Math.abs(thumbs.scrollTop - start) < 1) thumbs.scrollTop = target;
        sync();
      }, 320);
      setTimeout(sync, 620);
      sync();
    }
    function goUp() { glide(-stepSize(thumbs)); }
    function goDown() { glide(stepSize(thumbs)); }

    up.addEventListener('click', goUp);
    down.addEventListener('click', goDown);
    thumbs.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);

    var ro = null;
    if (window.ResizeObserver) { ro = new ResizeObserver(sync); ro.observe(thumbs); }

    sync();
    setTimeout(sync, 500);

    built.push({ up: up, down: down, thumbs: thumbs, sync: sync, ro: ro });
  }

  function teardown() {
    built.forEach(function (o) {
      o.thumbs.removeEventListener('scroll', o.sync);
      window.removeEventListener('resize', o.sync);
      if (o.ro) o.ro.disconnect();
      o.up.parentNode && o.up.parentNode.removeChild(o.up);
      o.down.parentNode && o.down.parentNode.removeChild(o.down);
    });
    built = [];
  }

  function apply() {
    if (MQ.matches) {
      Array.prototype.forEach.call(document.querySelectorAll('.mnsp .gallery'), build);
    } else {
      teardown();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
  if (MQ.addEventListener) MQ.addEventListener('change', apply);
  else if (MQ.addListener) MQ.addListener(apply);
})();
